<div class="relative">
    <!-- Disparador -->
    <button type="button" (click)="alternar()" [disabled]="disabled"
        class="flex w-full items-center gap-2.5 h-[42px] px-3 rounded-lg border bg-white text-left text-sm transition-colors disabled:bg-slate-50 disabled:text-slate-500 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-secondary/40"
        [ngClass]="error ? 'border-red-300' : 'border-slate-300 hover:border-slate-400'">

        <span *ngIf="seleccionado"
            class="h-6 w-6 shrink-0 rounded-full bg-blue-100 text-blue-700 text-[10px] font-bold flex items-center justify-center">
            {{ iniciales(seleccionado.name) }}
        </span>
        <lucide-icon *ngIf="!seleccionado" name="user" class="h-4 w-4 shrink-0 text-slate-400"></lucide-icon>

        <span class="flex-1 truncate" [ngClass]="seleccionado ? 'text-slate-900' : 'text-slate-500'">
            {{ textoBoton }}
        </span>

        <lucide-icon name="chevron-down" class="h-4 w-4 shrink-0 text-slate-400 transition-transform"
            [class.rotate-180]="abierto"></lucide-icon>
    </button>

    <!-- Desplegable con búsqueda -->
    <div *ngIf="abierto"
        class="absolute z-30 mt-1 w-full rounded-xl border border-slate-200 bg-white shadow-lg overflow-hidden">

        <div class="p-2 border-b border-slate-100">
            <!-- Icono a 12px + texto a 40px = 12px de aire, igual que en `app-input`.
                 Con `pl-8` el texto casi tocaba la lupa. -->
            <div class="relative">
                <lucide-icon name="search"
                    class="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400"></lucide-icon>
                <input data-buscador type="text" [(ngModel)]="filtro" (keydown)="teclado($event)"
                    [placeholder]="placeholder" autocomplete="off"
                    class="w-full h-10 pl-10 pr-3 bg-slate-50 border border-slate-200 rounded-lg text-sm outline-none focus:bg-white focus:border-blue-500 transition-all">
            </div>
        </div>

        <ul class="max-h-56 overflow-y-auto overscroll-contain py-1" role="listbox">
            <li *ngIf="permiteVacio && !filtro">
                <button type="button" (click)="elegir(null)"
                    class="w-full flex items-center gap-2 px-3 py-2 text-left text-sm hover:bg-slate-50 transition-colors"
                    [ngClass]="valor === null ? 'text-blue-700 font-semibold bg-blue-50/60' : 'text-slate-600'">
                    <lucide-icon name="user" class="h-4 w-4 shrink-0 text-slate-400"></lucide-icon>
                    {{ etiquetaVacio }}
                </button>
            </li>

            <li *ngFor="let u of filtrados; let i = index">
                <button type="button" (click)="elegir(u.id)" (mouseenter)="resaltado = i"
                    class="w-full flex items-center gap-2 px-3 py-2 text-left transition-colors"
                    [ngClass]="i === resaltado ? 'bg-slate-100' : 'hover:bg-slate-50'">
                    <span
                        class="h-7 w-7 shrink-0 rounded-full bg-blue-100 text-blue-700 text-[10px] font-bold flex items-center justify-center">
                        {{ iniciales(u.name) }}
                    </span>
                    <span class="min-w-0 flex-1">
                        <span class="block truncate text-sm"
                            [ngClass]="u.id === valor ? 'text-blue-700 font-semibold' : 'text-slate-800'">{{ u.name }}</span>
                        <span class="block truncate text-[11px] text-slate-400">{{ u.email }}</span>
                    </span>
                    <lucide-icon *ngIf="u.id === valor" name="check" class="h-4 w-4 shrink-0 text-blue-600"></lucide-icon>
                </button>
            </li>

            <li *ngIf="filtrados.length === 0" class="px-3 py-4 text-center text-sm text-slate-400">
                Ningún usuario activo coincide con «{{ filtro }}».
            </li>
        </ul>
    </div>
</div>

<p *ngIf="error" class="mt-1 text-sm text-red-600">{{ error }}</p>
